export default __webpack_public_path__ + "static/media/register_step4.21154753.svg";